import { format } from "date-fns"
import { useCallback, useEffect, useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router"

import ReportFilter from "../../components/filters/report"
import { AppDispatch } from "../../store"
import { BankEssential } from "../../store/actions/bank"
import { CampaignsState } from "../../store/actions/corporates"
import { createReport } from "../../store/actions/report"
import { RootState } from "../../store/reducers"

export interface IDatePicker {
	startDate: undefined | Date
	endDate: undefined | Date
	key: string
}

const Report = () => {
	const navigate = useNavigate()
	const dispatch = useDispatch<AppDispatch>()

	const authState = useSelector((state: RootState) => state.auth)
	const bankSelectedState: BankEssential | undefined = useSelector(
		(state: RootState) => state.banksUser.selected
	)
	const corporateIdSelected: string | undefined = useSelector(
		(state: RootState) => state?.corporatesUser?.selected?.id
	)
	const idBankForPaydoUser: string | undefined = useSelector(
		(state: RootState) => state.banksUser?.list?.[0]?.id
	)
	const campaignSelectedState: CampaignsState | undefined = useSelector(
		(state: RootState) => state.campaignsUser.selected
	)
	const corporateSelectedState = useSelector(
		(state: RootState) => state.corporatesUser.selected
	)

	const permissions = useSelector(
		(state: RootState) => state.auth?.user?.permissions
	)

	const hasReportEnabled: boolean = permissions
		? permissions.some(
				(perm) => perm.permissionName === "REPORT" && perm.enabled === true
			)
		: false

	const [filterBank, setFilterBank] = useState<undefined | string>(
		authState.user?.idBank ?? bankSelectedState?.id
	)

	const [filterCorporate, setFilterCorporate] = useState<undefined | string>(
		corporateIdSelected ?? authState.user?.corporateSenderId
	)

	const [filterCampaign, setFilterCampaign] = useState<undefined | string>(
		undefined
	)

	const [filterStatus, setFilterStatus] = useState<string[]>([])
	const [filterChannel, setFilterChannel] = useState<string[]>([])

	const [datePicker, setDatePicker] = useState<IDatePicker[]>([
		{
			startDate: null,
			endDate: null,
			key: "selection",
		},
	])

	const [openDialog, setOpenDialog] = useState<boolean>(false)

	const [filterFilename, setFilterFilename] = useState<string>("")

	useEffect(() => {
		setFilterCorporate(corporateIdSelected || authState.user?.corporateSenderId)
	}, [corporateIdSelected, authState.user?.corporateSenderId])

	useEffect(() => {
		!hasReportEnabled && navigate("/")
	}, [hasReportEnabled])

	const setFiltersFunc = useCallback(() => {
		const filter: { [key: string]: any } = {}

		if (filterBank) {
			filter.idBank = filterBank
		}
		if (filterCorporate) {
			filter.corporateSenderId = filterCorporate
		}
		if (filterCampaign) {
			filter.campaign = filterCampaign
		}
		if (filterFilename) {
			filter.filename = filterFilename
		}
		if (filterChannel.length > 0) {
			filter.channels = filterChannel
		}
		if (filterStatus.length > 0) {
			filter.statusPlick = filterStatus
		}
		if (datePicker?.[0]?.startDate || datePicker?.[0]?.endDate) {
			filter.rangeDate =
				format(datePicker?.[0]?.startDate as number | Date, "yyyy-MM-dd") +
				":" +
				format(datePicker?.[0]?.endDate as number | Date, "yyyy-MM-dd")
		}
		return filter
	}, [
		filterBank,
		filterCampaign,
		filterChannel,
		filterCorporate,
		filterFilename,
		filterStatus,
		datePicker?.[0]?.startDate,
		datePicker?.[0]?.endDate,
	])

	const handleGenerate = () => {
		const filters: { [key: string]: any } = setFiltersFunc()
		setOpenDialog(true)

		dispatch(createReport({ filter: filters }))
			.then(() => {
				setOpenDialog(false)
			})
			.catch(() => {
				setOpenDialog(false)
			})
	}
	return (
		<ReportFilter
			filterBank={filterBank}
			setFilterBank={setFilterBank}
			filterCampaign={filterCampaign}
			setFilterCampaign={setFilterCampaign}
			filterCorporate={filterCorporate}
			setFilterCorporate={setFilterCorporate}
			filterFilename={filterFilename}
			setFilterFilename={setFilterFilename}
			filterStatus={filterStatus}
			setFilterStatus={setFilterStatus}
			filterChannel={filterChannel}
			setFilterChannel={setFilterChannel}
			datePicker={datePicker}
			setDatePicker={setDatePicker}
			openDialog={openDialog}
			setOpenDialog={setOpenDialog}
			handleGenerate={handleGenerate}
		/>
	)
}

export default Report
